export default {
  staticHost: "https://dev.xiaolvgongkao.com",
  // staticHost: 'http://gaozhou.xlketang.cn',
  // staticHost: 'http://mac.txlt.com',

  devHost: "/dev_api",
  // devWebsocketHost:'ws://mac.txlt.com/wss',

  // devWebsocketHost:'ws://192.168.2.147/wss',
  // devHost: 'https://jiangdu.xlketang.cn',
  devWebsocketHost: "wss://jiangdu.xlketang.cn/wss",

  // websocketHost: 'wss://jiangdu.xlketang.cn/wss',













};
